import { render, staticRenderFns } from "./Vantagens.vue?vue&type=template&id=b2e5aa68&"
import script from "./Vantagens.js?vue&type=script&lang=js&"
export * from "./Vantagens.js?vue&type=script&lang=js&"
import style0 from "./Vantagens.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports